const VARINT_DATA_BITS = 7n
const VARINT_DATA_MASK = (1n << VARINT_DATA_BITS) - 1n // 0b01111111
const VARINT_CONTINUATION_BIT = 1n << VARINT_DATA_BITS // 0b10000000

const WIRE_TYPE_VARINT = 0
const WIRE_TYPE_LENGTH_DELIMITED = 2

const TAG_WIRE_TYPE_BITS = 3

export function encodeString(fieldNumber: number, value: string): Uint8Array {
  const tag = encodeTag(fieldNumber, WIRE_TYPE_LENGTH_DELIMITED)
  const data = new TextEncoder().encode(value)
  const length = encodeVarint(BigInt(data.length))

  return concatBytes(tag, length, data)
}

export function encodeInt64(fieldNumber: number, value: bigint): Uint8Array {
  const tag = encodeTag(fieldNumber, WIRE_TYPE_VARINT)
  const encodedValue = encodeVarint(value)

  return concatBytes(tag, encodedValue)
}

export function encodeMessage(
  fieldNumber: number,
  bytes: Uint8Array,
): Uint8Array {
  const tag = encodeTag(fieldNumber, WIRE_TYPE_LENGTH_DELIMITED)
  const length = encodeVarint(BigInt(bytes.length))

  return concatBytes(tag, length, bytes)
}

export function encodeCoin(denom: string, amount: string): Uint8Array {
  const encodedDenom = encodeString(1, denom)
  const encodedAmount = encodeString(2, amount)

  return concatBytes(encodedDenom, encodedAmount)
}

function encodeVarint(value: bigint): Uint8Array {
  let v = value
  const encodedBytes: number[] = []

  while (v > VARINT_DATA_MASK) {
    const dataBits = v & VARINT_DATA_MASK
    const byteWithContinuation = dataBits | VARINT_CONTINUATION_BIT

    encodedBytes.push(Number(byteWithContinuation))
    v >>= VARINT_DATA_BITS
  }

  encodedBytes.push(Number(v))

  return Uint8Array.from(encodedBytes)
}

function encodeTag(fieldNumber: number, wireType: number): Uint8Array {
  return Uint8Array.from([(fieldNumber << TAG_WIRE_TYPE_BITS) | wireType])
}

function concatBytes(...chunks: Uint8Array[]): Uint8Array {
  const totalLength = chunks.reduce((sum, c) => sum + c.length, 0)
  const result = new Uint8Array(totalLength)

  let offset = 0
  for (const chunk of chunks) {
    result.set(chunk, offset)
    offset += chunk.length
  }

  return result
}
